import {RecipientListSummary, RecipientOwnerInfo, RecipientToListAssociation} from "@/models/entities/ModelHelpers";
import {RecipientFilterCriteria} from "@/utilities/enums/Enums";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default class Recipient {
  id: number = -1;
  displayName: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  initials: string = '';
  owner: RecipientOwnerInfo = new RecipientOwnerInfo();
  listAssociations: RecipientToListAssociation = new RecipientToListAssociation();
  listCount: number = 0;
  recipientlistPreview:Array<RecipientListSummary> = [];
  activeTicketCount: number = 0;
  totalTicketCount: number = 0;
  isSystemUser: boolean = false;
  createdAt: string = getGermanIsoString();
  modifiedAt?: string | null = null;
  lastTicketSentAt?: string | null = null;
  isSelected: boolean = false;
  canEdit: boolean = true;
  canDelete: boolean = true;
  filterCriteria: RecipientFilterCriteria|null = null;
  filterValue: string|null = null;

  constructor(data: Record<string, any> | undefined = undefined) {
    Object.assign(this, data);
  }
}
